import { render, staticRenderFns } from "./PlatformYsf.vue?vue&type=template&id=1a92c31a&scoped=true"
import script from "./PlatformYsf.vue?vue&type=script&lang=js"
export * from "./PlatformYsf.vue?vue&type=script&lang=js"
import style0 from "./PlatformYsf.vue?vue&type=style&index=0&id=1a92c31a&prod&lang=scss&scoped=true"
import style1 from "./PlatformYsf.vue?vue&type=style&index=1&id=1a92c31a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a92c31a",
  null
  
)

export default component.exports